import React from 'react';
import EditTableViewForm, { EditTableViewFormProps } from './EditTableViewForm';
import { useMutation } from '../../../../../../graphql/hooks';
import { GET_SECTIONS, REMOVE_PLACE, UPDATE_PLACE_NAME } from '../../../../graphql';
import { TableMapQueryResult } from '../../Tables';

const EditTableForm = (props: Omit<EditTableViewFormProps, 'onRemoveClick' | 'onSubmit'> ) => {
    const [removePlace] = useMutation(REMOVE_PLACE);
    const [updatePlace] = useMutation(UPDATE_PLACE_NAME, { refetchQueries: [{ query: GET_SECTIONS }] });

    const onRemovePlace = async (placeId: string, sectionId: string) => {
        try {
            await removePlace({
                variables: { id: placeId },
                update: cache => {
                    const result: TableMapQueryResult | null = cache.readQuery({ query: GET_SECTIONS });
                    if(result){
                        const { sections } = result;
                        const updatedSections = sections.map(currentSection => {
                            const { id, places, ...rest } = currentSection;
                            if(id === sectionId){
                                if(places){
                                    const newPlaces = places.filter(place => (place.id !== placeId));
                                    return { id, places: newPlaces, ...rest };

                                }
                            }
                            return currentSection;
                        });
                        props.onClose();
                        cache.writeQuery({
                            query: GET_SECTIONS,
                            data: { sections: updatedSections }
                        });
                    }
                }
            });

        } catch(e) {
            // Nothing we can do
        }
    };

    const onUpdatePlace = async ({ placeId, name, isToGo }: { placeId: string; name: string; isToGo: boolean } ) => {
        try {
            await updatePlace({ variables: { id: placeId, name, isToGo } });
            props.onClose();
        } catch(e) {
            // Nothing we can do
        }
    };


    return <EditTableViewForm {...props} onSubmit={onUpdatePlace} onRemoveClick={onRemovePlace} />;
};

export default EditTableForm;
